/*
  rb-wishlist.js — wishlist without account (localStorage), recently viewed list.
  Storage keys: rb_wishlist (array of product handles), rb_recent (array of product handles).
  Nothing is sent to a server; data lives in the visitor's browser only.
*/
(function () {
  if (window.__rbWishlistInit) return;
  window.__rbWishlistInit = true;
  var WISH_KEY = 'rb_wishlist';
  var RECENT_KEY = 'rb_recent';
  var RECENT_MAX = 12;

  function read(key) {
    try {
      var raw = window.localStorage.getItem(key);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function write(key, arr) {
    try { window.localStorage.setItem(key, JSON.stringify(arr)); } catch (e) { /* storage blocked */ }
  }

  var RbWishlist = {
    list: function () { return read(WISH_KEY); },
    has: function (handle) { return read(WISH_KEY).indexOf(handle) !== -1; },
    add: function (handle) {
      var l = read(WISH_KEY);
      if (l.indexOf(handle) === -1) { l.unshift(handle); write(WISH_KEY, l); }
      RbWishlist.refresh();
    },
    remove: function (handle) {
      write(WISH_KEY, read(WISH_KEY).filter(function (h) { return h !== handle; }));
      RbWishlist.refresh();
    },
    toggle: function (handle) {
      if (RbWishlist.has(handle)) RbWishlist.remove(handle); else RbWishlist.add(handle);
      return RbWishlist.has(handle);
    },
    refresh: function () {
      var list = read(WISH_KEY);
      document.querySelectorAll('[data-rb-wish]').forEach(function (btn) {
        var on = list.indexOf(btn.getAttribute('data-rb-wish')) !== -1;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      document.querySelectorAll('.rb-wish-count').forEach(function (el) {
        el.textContent = String(list.length);
        el.hidden = list.length === 0;
      });
      document.dispatchEvent(new CustomEvent('rb:wishlist', { detail: { list: list } }));
    }
  };

  var RbRecent = {
    list: function () { return read(RECENT_KEY); },
    record: function (handle) {
      if (!handle) return;
      var l = read(RECENT_KEY).filter(function (h) { return h !== handle; });
      l.unshift(handle);
      write(RECENT_KEY, l.slice(0, RECENT_MAX));
    }
  };

  /* Fetch product JSON for a list of handles and render mini cards into a container. */
  function renderProducts(container, handles, opts) {
    opts = opts || {};
    var root = container.getAttribute('data-root') || '/';
    if (root.slice(-1) !== '/') root += '/';
    var grid = container.querySelector('[data-rb-grid]');
    var empty = container.querySelector('[data-rb-empty]');
    if (!grid) return;
    if (!handles.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      if (opts.hideWhenEmpty) container.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    container.hidden = false;
    var money = function (cents) {
      var fmt = container.getAttribute('data-money') || '{{amount_with_comma_separator}} €';
      var amount = (cents / 100).toFixed(2);
      if (fmt.indexOf('amount_with_comma_separator') !== -1) amount = amount.replace('.', ',');
      if (fmt.indexOf('amount_no_decimals') !== -1) amount = String(Math.round(cents / 100));
      return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, amount);
    };
    Promise.all(handles.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = '';
      products.forEach(function (p, i) {
        if (!p) return;
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '';
        var url = root + 'products/' + p.handle;
        var price = p.price_varies ? (container.getAttribute('data-from') || 'From') + ' ' + money(p.price_min) : money(p.price);
        html += '<li class="rb-mini-card">' +
          '<a class="rb-mini-card__media" href="' + url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="400" height="400">' : '') + '</a>' +
          '<div class="rb-mini-card__vendor">' + (p.vendor || '') + '</div>' +
          '<a class="rb-mini-card__title" href="' + url + '">' + p.title + '</a>' +
          '<div class="rb-mini-card__price">' + price + '</div>' +
          (opts.removable ? '<button type="button" class="rb-mini-card__remove" data-rb-remove="' + p.handle + '">' + (container.getAttribute('data-remove') || 'Remove') + '</button>' : '') +
          '</li>';
      });
      grid.innerHTML = html;
      if (!html) {
        if (empty) empty.hidden = false;
        if (opts.hideWhenEmpty) container.hidden = true;
      }
    });
  }

  function boot() {
    // PDP wishlist buttons
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rb-wish]');
      if (btn) {
        e.preventDefault();
        RbWishlist.toggle(btn.getAttribute('data-rb-wish'));
        return;
      }
      var rm = e.target.closest('[data-rb-remove]');
      if (rm) {
        e.preventDefault();
        RbWishlist.remove(rm.getAttribute('data-rb-remove'));
      }
    });

    // Record the current product (PDP)
    var current = document.querySelector('[data-rb-current-handle]');
    var currentHandle = current ? current.getAttribute('data-rb-current-handle') : null;
    if (currentHandle) RbRecent.record(currentHandle);

    // Recently viewed sections
    document.querySelectorAll('[data-rb-recent]').forEach(function (c) {
      var handles = RbRecent.list().filter(function (h) { return h !== currentHandle; }).slice(0, parseInt(c.getAttribute('data-limit') || '8', 10));
      renderProducts(c, handles, { hideWhenEmpty: true });
    });

    // Wishlist page section
    document.querySelectorAll('[data-rb-wishlist]').forEach(function (c) {
      var draw = function () { renderProducts(c, RbWishlist.list(), { removable: true }); };
      draw();
      document.addEventListener('rb:wishlist', draw);
    });

    RbWishlist.refresh();
  }

  window.RbWishlist = RbWishlist;
  window.RbRecent = RbRecent;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
